import { Injectable, Type } from '@angular/core';
import { BaseApiService } from '@kinet-open-network/client/core/api-client';
import { Liquidation } from '../models/liquidation.model';

@Injectable({
  providedIn: 'root',
})
export class LiquidationsService extends BaseApiService<Liquidation> {
  override model: Type<Liquidation> = Liquidation;

  override get endpoint(): string {
    return '/invoicing/liquidations';
  }
}
